
//
const createElement = require('../utils/createElement.js');

/**
 * Create a one way binding so as the property is updated, the DOM is also updated
 * @param  string target   Required - A selector or reference to the hidden input that this recaptcha is attached to
 * @param  string callback Optional - A callback to be executed after the recaptcha has a response
 * @return void
 */
module.exports = (target, callback) => {

    //
    const grecaptchaLoadedCallback = () => {

        //
        const grecaptchaInput = ((typeof target === 'string') ? document.querySelector(target) : target);

        //
        const grecaptchaContainer = createElement('div');

        //
        grecaptchaInput.parentElement.append(grecaptchaContainer);

        //
        grecaptchaInput.dataset.grecaptchaWidgetID = grecaptcha.render(grecaptchaContainer, {
            'sitekey'  : grecaptchaInput.dataset.grecaptchaSiteKey,
            'callback' : function(response) {
                grecaptchaInput.value = response;
                if (typeof callback === 'function') {
                    callback.call(grecaptchaInput, response);
                }
            }
        });

    }

    //if the grecaptcha function already exists, then the library has already loaded, so just call our loaded callback immediately
    if (typeof window.grecaptcha === 'function') {
        grecaptchaLoadedCallback();
        return;
    }

    //has the grecaptcha library already started to be loaded?
    if (typeof window.grecaptchaCallbacks === 'undefined' && typeof window.grecaptchaLoadedCallback === 'undefined') {

        //start loading the captcha api
        const captchaScript = createElement('script', {'src' : 'https://www.google.com/recaptcha/api.js?onload=grecaptchaLoadedCallback&render=explicit', 'async' : 'async', 'defer' : 'defer' });
        document.querySelector('head').append(captchaScript);

        //
        window.grecaptchaCallbacks = [];

        //
        window.grecaptchaLoadedCallback = () => {
            window.grecaptchaCallbacks.map((grecaptchaCallback) => {
                grecaptchaCallback();
            });
        }

    }

    //as it's already loading - just add our callback to the queue
    window.grecaptchaCallbacks.push(grecaptchaLoadedCallback);

};
